import React from "react";
import PropTypes from "prop-types";
import { Checkbox, FormControlLabel } from "@mui/material";
import { UIFieldShell, useUIField } from "../form";
import { clx } from "../../../utils/Helpers";
import "./UICheckbox.scss";

const UICheckboxIcon = ({ state }) => (
  <span className={`ui-checkbox__icon ui-checkbox__icon--${state}`}>
    {state === "checked" && (
      <svg viewBox="0 0 14 11" aria-hidden="true" focusable="false">
        <path d="M1 5.5L5 9.5L13 1.5" />
      </svg>
    )}
    {state === "indeterminate" && <span className="ui-checkbox__dash" />}
  </span>
);

const UICheckbox = ({
  name,
  checked,
  helperText,
  error,
  onChange,
  onBlur,
  label,
  disabled,
  className,
  ...props
}) => {
  const field = useUIField({
    name,
    checked,
    error,
    helperText,
  });

  return (
    <UIFieldShell helperText={field.helperText} error={field.showError}>
      <FormControlLabel
        className="ui-checkbox-label"
        control={
          <Checkbox
            className={clx("ui-checkbox", className)}
            checked={field.checked}
            icon={<UICheckboxIcon state="unchecked" />}
            checkedIcon={<UICheckboxIcon state="checked" />}
            indeterminateIcon={<UICheckboxIcon state="indeterminate" />}
            onChange={(event, nextChecked) => {
              field.setValue(nextChecked);
              onChange?.(nextChecked, event);
            }}
            onBlur={(event) => {
              field.setTouched(true);
              onBlur?.(event);
            }}
            disabled={disabled}
            {...props}
          />
        }
        label={label}
        disabled={disabled}
      />
    </UIFieldShell>
  );
};

UICheckboxIcon.propTypes = {
  state: PropTypes.oneOf(["unchecked", "checked", "indeterminate"]).isRequired,
};

UICheckbox.propTypes = {
  name: PropTypes.string,
  checked: PropTypes.bool,
  helperText: PropTypes.node,
  error: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  label: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

UICheckbox.defaultProps = {
  name: undefined,
  checked: undefined,
  helperText: null,
  error: undefined,
  onChange: undefined,
  onBlur: undefined,
  disabled: false,
  className: "",
};

export default UICheckbox;
